import { DebtsScreen } from './DebtsScreen.jsx';

export default {
  path: '/debts',
  element: <DebtsScreen />,
  protected: true,
  permission: null,
  // من يُحصّل الدين يرى الشاشة أيضاً (يفرض الخادم نفس الشرط).
  anyPermission: ['debts.view', 'debts.settle'],
  standalone: false,
  sidebar: { label: 'ديون العملاء', icon: 'finance', group: 'finance', order: 79 }
};
